'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresNumOfPassengersSelect = function () {
    function WinresNumOfPassengersSelect($scope, $rootScope, $filter, $document, urlService) {
        var _this = this;

        _classCallCheck(this, WinresNumOfPassengersSelect);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$document = $document;
        this.urlService = urlService;

        this.$scope.status = [];
        this.$scope.status.isopen = false;

        this.$scope.toggled = function (open) {
            if (!open) {
                _this.onClickPassengerAmountOKButton();
            }
        };
    }

    _createClass(WinresNumOfPassengersSelect, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-num-of-passengers-select]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                // Change passenger amounts only once to prevent passenger amount reset on OK click.
                if (!_this2.numAdults && !_this2.numChildren && !_this2.numInfants) {
                    // Get passenger amounts from context.
                    _this2.numAdults = _this2.data.NumAdults;
                    _this2.numChildren = _this2.data.NumChildren;
                    _this2.numInfants = _this2.data.NumInfants;
                }
            }, true);

            this.initAges();
        }
    }, {
        key: 'initAges',
        value: function initAges() {
            var _this3 = this;

            this.infantAges = this.infantAges || '0-1';
            this.childAges = this.childAges || '2-15';
            this.adultAge = this.adultAge || '16+';

            var _childAges$split = this.childAges.split('-'),
                _childAges$split2 = _slicedToArray(_childAges$split, 2),
                min = _childAges$split2[0],
                max = _childAges$split2[1];

            this.childAge = { min: min, max: max };

            this.ChildrenAges = this.data.ChildrenAges || [];

            // Set default arrival ages for passengers.
            this.$scope.$watchCollection('$ctrl.data.Passengers', function () {
                var children = _.filter(_this3.data.Passengers, function (passenger) {
                    return passenger.IsChild;
                });

                _.each(children, function (child, idx) {
                    _this3.ChildrenAges[idx] = { 'Age': child.ArrivalAge || 3 };
                });

                _this3.data.ChildrenAges = _this3.ChildrenAges;
                _this3.updateArrivalAges();
            }, true);

            // Watch and update children arrival ages.
            this.$scope.$watch('$ctrl.ChildrenAges', function () {
                _this3.data.ChildrenAges = _this3.ChildrenAges;
                _this3.updateArrivalAges();
            }, true);
        }
    }, {
        key: 'updateArrivalAges',
        value: function updateArrivalAges() {
            var _this4 = this;

            // Infant arrival age is 2
            _.each(_.filter(this.data.Passengers, function (passenger) {
                return passenger.IsInfant;
            }), function (infant) {
                infant.ArrivalAge = 2;
            });

            // Set child arrival ages
            // Assuming children are in same order as ChildrenAges
            _.each(_.filter(this.data.Passengers, function (passenger) {
                return passenger.IsChild;
            }), function (child, idx) {
                child.ArrivalAge = _this4.ChildrenAges[idx] ? _this4.ChildrenAges[idx].Age : 3;
            });

            // Get adult arrival age from adultAge
            _.each(_.filter(this.data.Passengers, function (passenger) {
                return passenger.IsAdult || passenger.IsCustomer;
            }), function (adult) {
                adult.ArrivalAge = +_this4.adultAge.split('+')[0];

                if (adult.IsCustomer) {
                    _this4.data.Customer.IsCustomer = true;
                    _this4.data.Customer.ArrivalAge = adult.ArrivalAge;
                }
            });
        }
    }, {
        key: 'onClickPassengerAmountOKButton',
        value: function onClickPassengerAmountOKButton() {
            if (this.data.NumAdults !== this.numAdults || this.data.NumChildren !== this.numChildren || this.data.NumInfants !== this.numInfants) {
                // Change passenger amounts in url and in context.
                this.updatePassengerAmounts(this.numAdults, this.numChildren, this.numInfants);
            }

            // Close number of passengers modal.
            this.$scope.status.isopen = false;
        }
    }, {
        key: 'updatePassengerAmounts',
        value: function updatePassengerAmounts(numAdults, numChildren, numInfants) {
            var urlParams = this.winresReservationContext.getUrlParams();

            // Change numAdults, numChildren and numInfants in url.
            this.urlService.setParamsToUrl({
                dn: urlParams.DestinationName,
                dc: urlParams.DestinationCode,
                pc: urlParams.ProductCode,
                bd: urlParams.StartDate,
                ed: urlParams.EndDate,
                na: numAdults,
                nc: numChildren,
                ni: numInfants
            }, false);

            // Update url params in context.
            this.winresReservationContext.initUrlData();

            // Context still has passenger amounts from previous url, change passenger amounts correctly.
            this.winresReservationContext.Params.NumAdult = numAdults;
            this.winresReservationContext.Params.NumChildren = numChildren;
            this.winresReservationContext.Params.NumInfants = numInfants;

            // Update passengers.
            this.winresReservationContext.initPassengerFieldsBase();
            this.winresReservationContext.initPassengers();
        }
    }, {
        key: 'getPassengerAmount',
        value: function getPassengerAmount() {
            if (this.numChildren === 0 && this.numInfants === 0 && this.numAdults === 0) {
                return 0 + ' ' + this.$filter('i18next')('number_of_people.person');
            } else if (this.numChildren === 0 && this.numInfants === 0) {
                if (this.numAdults === 1) {
                    return this.numAdults + ' ' + this.$filter('i18next')('number_of_people.adult');
                } else {
                    return this.numAdults + ' ' + this.$filter('i18next')('number_of_people.adults');
                }
            } else {
                return this.numAdults + this.numChildren + this.numInfants + ' ' + this.$filter('i18next')('number_of_people.person');
            }
        }
    }]);

    return WinresNumOfPassengersSelect;
}();

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl(getWebcomponentsUrl($attrs.templateUrl)) : 'numOfPassengersSelect';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('numOfPassengersSelect', require('./winresNumOfPassengersSelect.html'));
}]);

WinresNumOfPassengersSelect.$inject = ['$scope', '$rootScope', '$filter', '$document', 'urlService'];

_module3.default.component('winresNumOfPassengersSelect', {
    templateUrl: getTemplate,
    controller: WinresNumOfPassengersSelect,
    bindings: {
        // Infant ages in num of passengers form
        infantAges: '@',
        // Child ages in num of passengers form
        childAges: '@',
        // Adult age in num of passengers form
        adultAge: '@',
        showNumOfAdults: '@',
        showNumOfChildren: '@',
        showNumOfInfants: '@',
        askChildrenAges: '@'
    },
    require: {
        winresReservationContext: '?^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresNumOfPassengersSelect/winresNumOfPassengersSelect.js
// module id = 512
// module chunks = 2